import React from 'react';

interface DropdownMapAreasProps {
  areas: { designatedArea: string }[];
}

const DropdownMapAreas: React.FC<DropdownMapAreasProps> = ({ areas }) => {
  if (!areas || areas.length === 0) return null;

  return (
    <details>
      <summary style={{ cursor: 'pointer' }}>Ver locais</summary>
      <ul style={{ marginTop: 4, paddingLeft: 16 }}>
        {areas.map((area, index) => (
          <li key={index}>{area.designatedArea}</li>
        ))}
      </ul>
    </details>
  );
};

export default DropdownMapAreas;
